import { ChevronDown, ChevronUp } from "lucide-react";
import { SelectBuy } from "./SelectBuy";
import { SelectInvoice } from "./SelectInvoice";
import { Autocomplete, createFilterOptions, TextField } from "@mui/material";
import NumberFormat from "react-number-format";
import { useState } from "react";

const filter = createFilterOptions();

export const RowFlows = ({
  flo,
  handleChangeNumber,
  handleChangeDate,
  handleChangeHito,
  handleChangeSupplier,
  listSuppliers,
  handleChangeDoc,
  listaTiposDocumentos,
  valor_tipo_cambio,
  simbolo,
  separacion_miles,
  separacion_decimales,
  setOpenResumen,
  openResumen,
  id_moneda,
  hitosList,
  handleRemoveInvoice,
  handleOpenNewInvoice,
  handleChangeSelectInvoice,
  invoicesList,
  handleChangeSelectBuy,
  buysList,
  handleRemove,
  handleItemSelected,
  handleChangeRef,
}) => {
  const [openRow, setOpenRow] = useState(false);
  const [isHovered, setIsHovered] = useState(false);

  const handleInputRef = ({ target }, id) => {
    handleChangeRef(target.value, id);
  };

  return (
    <tr
      className="p-tr-body-global"
      key={flo.id}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <td className="sticky left-0 z-5">
        <div className="flex items-center">
          <div
            className={`text-xs font-bold p-1 rounded ${flo.tipo_flujo === "ingreso" ? "text-emerald-700" : "text-red-500"}`}
          >
            {flo.tipo_flujo === "ingreso" ? "ING" : "EGR"}
          </div>
          {/* <div
            className="ms-2 p-1 cursor-text"
            contentEditable
            onInput={(e) => handleInputRef(e, flo.id)}
          >
            {flo?.referencia}
          </div> */}
          <div>
            <input
              className="ms-2 p-1 uppercase"
              type="text"
              value={flo?.referencia}
              onChange={(e) => handleInputRef(e, flo.id)}
            />
          </div>
        </div>

        {openRow && (
          <div className="absolute mt-2">
            <select
              style={{
                border: "1px solid lightgray",
                padding: "2px",
                backgroundColor: "white",
                width: "180px",
                borderRadius: "3px",
                textAlign: "left",
                textTransform: "uppercase",
              }}
              name="id_doc"
              onChange={(e) => handleChangeDoc(e, flo.id)}
            >
              <option key="" value="">
                --seleccionar--
              </option>
              {listaTiposDocumentos?.map((doc) => (
                <option
                  key={doc.id}
                  selected={
                    parseInt(doc.id) === parseInt(flo?.id_doc) ? "selected" : ""
                  }
                  value={doc.id}
                >
                  {doc.nombre}
                </option>
              ))}
            </select>
            <span className="ms-2">
              <NumberFormat
                style={{ fontSize: "13px" }}
                displayType="text"
                value={parseFloat(flo.porcentaje_impuesto)}
                thousandSeparator={separacion_miles}
                decimalSeparator={separacion_decimales}
                decimalScale={0}
                suffix="%"
              />
            </span>
          </div>
        )}
      </td>
      <td>
        <div className="d-flex justify-content-start align-items-end">
          <div className="d-flex flex-column justify-content-start align-items-end relative">
            <NumberFormat
              className="text-end p-cantidades-item-new2"
              style={{
                width: "150px",
                border: flo?.info_invoice ? "none" : "",
                fontSize: "12px",
              }}
              name="monto_neto"
              value={parseFloat(flo?.monto_neto || 0)}
              thousandSeparator={flo?.separacion_miles || separacion_miles}
              decimalSeparator={
                flo?.separacion_decimales || separacion_decimales
              }
              prefix={`${flo?.simbolo || simbolo} `}
              decimalScale={2}
              fixedDecimalScale={2}
              onValueChange={(values, sourceInfo) =>
                handleChangeNumber({ ...values, sourceInfo }, flo.id)
              }
              disabled={flo?.info_invoice ? true : false}
            />

            {parseInt(flo?.id_moneda) === 3 && parseInt(id_moneda) === 4 ? (
              <NumberFormat
                className="text-end p-cantidades-item-new2"
                style={{
                  width: "150px",
                  border: flo?.info_invoice ? "none" : "",
                  fontSize: "10px",
                  marginTop: "5px",
                }}
                displayType={"text"}
                name="monto_neto"
                value={parseFloat((flo?.monto_neto || 0) / valor_tipo_cambio)}
                thousandSeparator={separacion_miles}
                decimalSeparator={separacion_decimales}
                prefix={`${simbolo} `}
                decimalScale={2}
                fixedDecimalScale={2}
                onValueChange={(values, sourceInfo) =>
                  handleChangeNumber({ ...values, sourceInfo }, flo.id)
                }
                disabled={flo?.info_invoice ? true : false}
              />
            ) : (
              ""
            )}

            {openRow && (
              <>
                <div className="text-xs">
                  <NumberFormat
                    className="text-xs"
                    displayType="text"
                    value={parseFloat(flo.total)}
                    thousandSeparator={
                      flo?.separacion_miles || separacion_miles
                    }
                    decimalSeparator={
                      flo?.separacion_decimales || separacion_decimales
                    }
                    decimalScale={2}
                    fixedDecimalScale={2}
                    prefix={`${flo?.simbolo || simbolo} `}
                  />
                </div>
                {parseInt(id_moneda) === 4 && (
                  <div>
                    (tc:
                    <NumberFormat
                      className="text-xs"
                      displayType="text"
                      value={parseFloat(flo.valor_tipo_cambio)}
                      thousandSeparator={","}
                      decimalSeparator={"."}
                      decimalScale={2}
                      fixedDecimalScale={2}
                      /*  prefix={`S/ `} */
                    />
                    )
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </td>
      <td className="text-center">
        <input
          style={{
            padding: "2px",
            borderRadius: "3px",
            border: "1px solid lightgray",
          }}
          type="date"
          value={flo?.fecha_proyeccion}
          onChange={(value) => handleChangeDate(value, flo.id)}
          disabled={flo?.info_invoice ? true : false}
        />
      </td>
      <td>
        <select
          style={{
            border: "1px solid lightgray",
            padding: "2px",
            backgroundColor: "white",
            width: "200px",
            borderRadius: "3px",
            textAlign: "left",
            textTransform: "uppercase",
          }}
          name="id_tarea"
          onChange={(e) => handleChangeHito(e, flo.id)}
          disabled={flo?.info_invoice ? true : false}
        >
          <option key="" value="">
            --
          </option>
          {hitosList?.map((hi) => (
            <>
              <option
                key={hi.id}
                selected={hi.id === flo?.id_tarea ? "selected" : ""}
                value={hi.id}
              >
                HITO: {hi.nombre}
              </option>
              {hi?.subs?.map((ta) => (
                <>
                  <option
                    key={ta.id}
                    selected={ta.id === flo?.id_tarea ? "selected" : ""}
                    value={ta.id}
                    className="p-2"
                  >
                    --TA: {ta.nombre} / (HITO: {hi.nombre})
                  </option>
                  {ta?.subs?.map((st) => (
                    <option
                      key={st.id}
                      selected={st.id === flo?.id_tarea ? "selected" : ""}
                      value={st.id}
                      className="p-2"
                    >
                      ----ST: {st.nombre} / (HITO: {hi.nombre})
                    </option>
                  ))}
                </>
              ))}
              <hr />
            </>
          ))}
        </select>
      </td>
      <td className="text-center">
        {flo.tipo_flujo === "egreso" ? (
          <div
            className="p-text-autocomplete border rounded"
            style={{ width: "200px" }}
          >
            <Autocomplete
              value={
                listSuppliers?.find(
                  (it) => parseInt(it.id) === parseInt(flo?.id_contacto),
                ) || null
              }
              onChange={(e, newValue) => handleChangeSupplier(e, newValue, flo)}
              filterOptions={(options, params) => {
                const filtered = filter(options, params);
                return filtered;
              }}
              id="auto-complete"
              autoComplete
              includeInputInList
              fullWidth
              options={listSuppliers}
              getOptionLabel={(option) => {
                if (typeof option === "string") {
                  return option;
                }

                return option.nombre;
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="--seleccionar--"
                  /* variant="standard" */
                  style={{ textTransform: "capitalize" }}
                />
              )}
            />
          </div>
        ) : (
          "---"
        )}
      </td>
      <td className="text-center relative">
        <div className="flex items-end justify-end relative">
          {flo.estado === "pendiente" ? (
            <span className="p-1 ps-2 pe-2 rounded-xl text-[13px] capitalize border-1 bg-amber-50 text-amber-700 border-amber-20 font-semibold">
              {flo.estado}
              {flo?.info_invoice && (
                <i
                  className={`bi bi-check-circle-fill ${flo?.tipo_flujo === "ingreso" ? "text-green-500" : "text-red-500"} ms-1`}
                ></i>
              )}
            </span>
          ) : (
            <span className="p-1 ps-2 pe-2 rounded-xl text-[13px] capitalize border-1 bg-emerald-100 text-emerald-700 border-emerald-200 font-semibold">
              {flo.estado}
            </span>
          )}
          <button
            className="flex items-center ms-2"
            onClick={() => setOpenRow(!openRow)}
          >
            {openRow ? (
              <ChevronUp className="w-4 h-4" />
            ) : (
              <ChevronDown className="w-4 h-4" />
            )}
          </button>
        </div>
        {openRow && (
          <div className="mt-2">
            {flo.tipo_flujo === "ingreso" ? (
              <SelectInvoice
                flo={flo}
                handleRemoveInvoice={handleRemoveInvoice}
                handleOpenNewInvoice={handleOpenNewInvoice}
                handleChangeSelectInvoice={handleChangeSelectInvoice}
                invoicesList={invoicesList}
              />
            ) : (
              <SelectBuy
                flo={flo}
                handleRemoveInvoice={handleRemoveInvoice}
                handleOpenNewInvoice={handleOpenNewInvoice}
                handleChangeSelectBuy={handleChangeSelectBuy}
                invoicesList={buysList}
              />
            )}
          </div>
        )}
        <div
          style={{ visibility: isHovered ? "visible" : "hidden" }}
          className="absolute right-1 bottom-0"
        >
          <i
            title="Eliminar flujo"
            className="bi bi-trash"
            style={{
              cursor: "pointer",
              fontSize: "13px",
              verticalAlign: "middle",
            }}
            onClick={() => handleRemove(flo.id)}
          ></i>
        </div>
      </td>
      {/* <td className="hidden">
                {!flo?.info_invoice ?
                    < i
                        className="bi bi-trash"
                        style={{ cursor: 'pointer', fontSize: '15px', verticalAlign: 'middle' }}
                        onClick={() => handleRemove(flo.id)}
                    ></i> : ''
                }
            </td>
            <td className="text-center hidden">
                {(!flo?.info_invoice && flo?.tipo_flujo !== 'ingreso') ?
                    <input
                        type="checkbox"
                        style={{ verticalAlign: 'middle' }}
                        className="p-normal-checkbox"
                        onChange={(e) => handleItemSelected(e, flo)}
                    /> : ''
                }
            </td> */}
    </tr>
  );
};
